import { createSlice } from '@reduxjs/toolkit';
import { generateStateSingle } from '../../generators/generateState';
import {
    createData,
    deleteData,
    editData,
    fetchData,
    fetchEditData,
} from '../../generators/generateThunks';

const SLICE_NAME = 'greyPurchaseOrder';

export const createGreyPurchaseOrder = createData.generateThunk(
    SLICE_NAME,
    SLICE_NAME
);

export const fetchGreyPurchaseOrders = fetchData.generateThunk(SLICE_NAME,SLICE_NAME);

export const fetchGreyPurchaseOrder = fetchEditData.generateThunk(SLICE_NAME,SLICE_NAME);

const greyPurchaseOrderSlice = createSlice({
    initialState: generateStateSingle(SLICE_NAME),
    name: SLICE_NAME,
    extraReducers: {
        ...createData.generateExtraReducers(createGreyPurchaseOrder, SLICE_NAME),
        ...fetchData.generateExtraReducers(fetchGreyPurchaseOrders, SLICE_NAME),
        ...fetchEditData.generateExtraReducers(fetchGreyPurchaseOrder,SLICE_NAME),
    },
});

export const getGreyPurchaseOrders = (state) => state.greyPurchaseOrder;

export default greyPurchaseOrderSlice.reducer;
